<template>
  <div class="dot__div--box" ref="slefer">
    <ul class="dot__ul">
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <ul class="check__div--pos" v-show="show" >
      <li v-for="item in keys" :key="item.key">
        <el-checkbox @change="onChange(item)" v-model="item.checked">
          {{ item.title }}
        </el-checkbox>
      </li>
      <li v-if="!keys.length">
        <el-empty :image-size="60"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CustomizeChoose",
  props: {
    columnsTags: {
      type: Array,
      default: () => []
    },
    filterSoltHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keys: [],
      show: false
    }
  },
  watch: {
    columnsTags: {
      handler: function (newVal) {
        // console.log('newVal', newVal)
        const _columnsTags = newVal.filter(item => this.filterSoltHeader || !item.scopedSlots).map(item => {
          const {title, key} = item
          return {
            title,
            key,
            checked: true
          }
        })
        const _keys = _columnsTags.filter(item => {
          let flag = true
          if (item.title === '#') {
            flag = false
          }
          return flag
        })
        this.keys = JSON.parse(JSON.stringify(_keys))
        this.$emit('input', this.keys) // 用于 v-model
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    // 点击其他不在的区域触发事件
    document.addEventListener('click', this.close)
  },
  destroyed() {
    document.removeEventListener('click', this.close)
  },
  methods: {
    onChange: function () {
      this.$emit('input', this.keys) // 用于 v-model
    },
    close: function (el) {
      if(this.$refs.slefer.children[0].contains(el.target)) { // 点中 dot__ul 时 show 取反
        this.show = !this.show
      } else  { // 其他情况查看， 是否点中 dot__div--box 如果不是，说明点中了外面，就隐藏
        this.show = this.$refs.slefer.contains(el.target);
      }
      // console.log(this.show)
    }
  }
}
</script>

<style scoped>

.dot__div--box {
  height: 20px;
  position: relative;
  top: 0;
  left: 0;
}

.dot__ul {
  height: 20px;
  margin-left: auto;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.dot__ul > li {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6b6b6b;
  margin: 0 2px;
}

.dot__ul:hover > li {
  background: #1bc318;
}

.check__div--pos {
  position: absolute;
  top: 0;
  right: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 12px 20px;
  width: 300px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.05);
  z-index: 999;
}
.check__div--pos > li {
  padding: 0 14px;
}
</style>
